import { useState } from 'react';
import { getInvoiceNumbers } from '../../../../config/LiveApi';
import { toast } from 'react-toastify';

const GetInvoiceNo = ({ token }) => {
    const [utrInput, setUtrInput] = useState('');
    const [invoices, setInvoices] = useState([]);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSearch = async () => {
        setLoading(true);
        try {
            const utrs = utrInput.split(',').map(utr => utr.trim()).filter(Boolean);
            const res = await getInvoiceNumbers(token, utrs);
            setInvoices(res.data);
            setError('');
        } catch (err) {
            setError('Error fetching invoice numbers.');
            setInvoices([]);
        } finally {
            setLoading(false);
        }
    };

    const handleCopy = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            toast("Copied to clipboard!");
        } catch (err) {
            console.error('Failed to copy!', err);
            toast.error("Failed to copy!");
        }
    };

    return (
        <>
            <div className="cbe-search-bar">
                <input
                    type="text"
                    placeholder="Enter UTRs"
                    value={utrInput}
                    onChange={(e) => setUtrInput(e.target.value)}
                />
                <button onClick={handleSearch}>Search</button>
            </div>

            {loading && <div className="cbe-loading">🔄 Loading...</div>}

            {
                !loading && invoices.length > 0 && (
                    <div className="cbe-table-wrapper">
                        <table className="cbe-table">
                            <thead>
                                <tr>
                                    <th>UTR</th>
                                    <th>Invoice Number</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoices.map(({ utr, invoiceNumber }, index) => (
                                    <tr key={index}>
                                        <td>{utr}</td>
                                        <td>{invoiceNumber}</td>
                                        <td style={{ textAlign: "center" }}>
                                            <button onClick={() => handleCopy(invoiceNumber)} className='cbe-copy-btn-2'>Copy</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )
            }

            {!loading && error && <div className="cb-error-message">{error}</div>}
        </>
    );
};

export default GetInvoiceNo;
